// extracted by mini-css-extract-plugin
module.exports = {"IncompleteInfo":"OrderItem_IncompleteInfo__inPhX","AddUnitsLink":"OrderItem_AddUnitsLink__3Vw3A"};